<template>
    <!-- 0 disapprovals -->
    <div v-if="totalNumberOfEntities === 0" class="disapproval-status-block">
        <div class="header">
            <!-- Check Icon -->
            <DisapprovalsNone />
            <Spacer width="0.625rem" />
            <Text class="heading-text" as="p" weight="600" color="gray">
                0 {{ entity }}s Detected
            </Text>
        </div>
        <div class="footer">
            <Text as="p" size="f-8" color="gray">
                <b>0</b> {{ entity.toLowerCase() }}s were detected in your account.
            </Text>
        </div>
    </div>

    <!-- Has disapprovals -->
    <div v-else-if="numberOfDisapprovedEntities > 0" class="disapproval-status-block">
        <div class="header">
            <!-- Warn Icon -->
            <DisapprovalsWarn />
            <Spacer width="0.625rem" />
            <Text class="heading-text" as="p" weight="600" color="red">
                <NumberVue :value="numberOfDisapprovedEntities" />
                {{ entity }} Disapproval{{ numberOfDisapprovedEntities > 1 ? 's' : '' }}
            </Text>
        </div>
        <div class="footer">
            <Text as="p" size="f-8">
                <b><NumberVue :value="numberOfDisapprovedEntities" /></b> of
                <b><NumberVue :value="totalNumberOfEntities" /></b> {{ entity.toLowerCase() }}s have
                outstanding disapprovals.
            </Text>
        </div>
    </div>

    <!-- No disapprovals -->
    <div v-else class="disapproval-status-block">
        <div class="header">
            <!-- Check Icon -->
            <DisapprovalsCheck />
            <Spacer width="0.625rem" />
            <Text class="heading-text" as="p" weight="600" color="green">
                0 {{ entity }} Disapprovals
            </Text>
        </div>
        <div class="footer">
            <Text as="p" size="f-8">
                <b>0</b> of <b><NumberVue :value="totalNumberOfEntities" /></b>
                {{ entity.toLowerCase() }}s have outstanding disapprovals.
            </Text>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { Text, Spacer, Number as NumberVue } from '@opteo/components-next'

import DisapprovalsCheck from './DisapprovalsCheck.vue'
import DisapprovalsWarn from './DisapprovalsWarn.vue'
import DisapprovalsNone from './DisapprovalsNone.vue'

const props = defineProps<{
    entity: string
    totalNumberOfEntities: number
    numberOfDisapprovedEntities: number
}>()
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
@import '@/assets/css/variables.scss';

.disapproval-status-block {
    @include container;
    @include br-20;
    & .footer {
        @include flex;
        @include items-center;
        padding: 1rem 1.5rem 1.125rem 1.5rem;
        & p {
            line-height: 1.25rem;
        }
    }
    & .header {
        @include flex;
        @include items-center;
        padding: 1.375rem 1.5rem;
        border-bottom: 1px solid $opteo-light-gray;
        & .heading-text {
            font-size: 1.125rem;
            letter-spacing: -0.015rem;
        }
    }
}
</style>
